<template lang="pug">
  .table__content(
    :class="sortedMsgList.length === 0 && 'traction__map-empty'"
    )

    template(v-if="isLoadMsg")
      SkeletonTable(v-for="i in 3" :key="i+'-skeleton'")

    template(v-else-if="!isLoadMsg && sortedMsgList.length > 0")
      MsgList.msg-block(
        v-for="( data, idx ) in sortedMsgList" :key="idx+'-msg'"
        :data="data"
      )

    TableEmpty.padding-top-20.position-top(v-else)
</template>

<script>
import { mapState, mapActions } from 'vuex';
import MsgList from './MsgList';
import SkeletonTable from './components/Skeleton/SkeletonTable';

export default {
  components: { MsgList, SkeletonTable },
  computed: {
    ...mapState('msg', {
      users: s => s.data.users,
      analytics: s => s.data.analytics,
      isLoadMsg: s => s.meta.isLoadMsg,
      searchingUsers: s => s.data.searchingUsers
    }),
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.userTeamModuleAdmin,
      userId: s => s.data.user.id
    }),
    isAdmin() {
      return this.$permissionsPointUpdate == 2;
    },
    sortedMsgList() {
      return this.analyticsList.filter(el => {
        if (
          el.user.name.toLowerCase().includes(this.searchingUsers.toLowerCase())
        ) {
          return el;
        }
        if (
          el.user.lastname
            .toLowerCase()
            .includes(this.searchingUsers.toLowerCase())
        ) {
          return el;
        }
      });
    },
    analyticsList() {
      return [
        ...this.analytics.map(el => {
          const user = this.users.find(person => person.id === el.info.userId);
          if (user) {
            el.user = { ...user };
          }

          return { ...el };
        })
      ];
    }
  },
  methods: {
    ...mapActions('tractionMap', ['setData'])
  }
};
</script>
